<div class="chart">
    <canvas class="canvas-element" baseChart [data]="barChartData" [options]="barChartOptions" [type]="barChartType"></canvas>
</div>